<template>
  <div :style="{height:height,zIndex:zIndex}">
    <div
      :class="className"
      :style="{top:(isSticky ? stickyTop +'px' : ''),zIndex:zIndex,position:position,width:width,height:height}"
    >
      <slot>
        <div>sticky</div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sticky",
  props: {
    stickyTop: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    className: {
      type: String,
      default: "",
    },
    right: {
      type: String,
      default: "20px",
    },
    left: {
      type: String,
      default: "",
    },
    searchAreaStatus: {
      type: Boolean,
      defautl: false,
    },
  },
  data() {
    return {
      active: false,
      position: "",
      width: undefined,
      height: undefined,
      isSticky: false,
    };
  },
  mounted() {
    // this.height = this.$el.getBoundingClientRect().height + "px";
    // console.log("height:", this.height);
    this.$nextTick(() => {
      this.height = this.$el.getBoundingClientRect().height + "px";
      console.log("height:", this.height);
    });
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);

    this.$once("hook:beforeDestroy", function () {
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleResize);
    });
  },
  // activated() {
  //   this.handleScroll();
  // },

  methods: {
    sticky() {
      if (this.active) {
        return;
      }
      this.position = "fixed";
      this.active = true;
      this.width = this.width + "px";
      this.isSticky = true;
    },
    handleReset() {
      if (!this.active) {
        return;
      }
      this.reset();
    },
    reset() {
      this.position = "";
      this.width = "auto";
      this.active = false;
      this.isSticky = false;
    },
    handleScroll() {
      const width = this.$el.getBoundingClientRect().width;
      this.width = width || "auto";
      const offsetTop = this.$el.getBoundingClientRect().top;
      if (offsetTop < this.stickyTop) {
        this.sticky();
        return;
      }

      this.handleReset();
    },
    handleResize() {
      if (this.isSticky) {
        this.width = this.$el.getBoundingClientRect().width + "px";
      }
    },
  },
  // watch: {
  //   searchAreaStatus: function (value) {
  //     // this.height = "auto";
  //     console.log("height", this.height);
  //     this.height = this.$el.getBoundingClientRect().height + "px";
  //   },
  // },
  watch: {
    searchAreaStatus: {
      handler: function (val) {
        // 计算fixed 区域的高度
        // 切换折叠状态后，需要获取渲染一次后的dom高度
        setTimeout(() => {
          // this.topAreaHeight = document.getElementById('topArea').getBoundingClientRect().height + 'px'
          // console.log("topAreaHeight", this.topAreaHeight)
          this.height =
            document.getElementById("topArea").getBoundingClientRect().height +
            "px";
          console.log("height", this.height);
        });
      },
      // immediate: true
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/base/Sticky/index.vue